import { Router } from 'aurelia-router';
import { autoinject } from 'aurelia-framework';
import { Account } from '../../../../models/customer';
import { SelectedAccountsSettings } from '../selected-accounts-settings';

@autoinject
export class CardRecurringSetup {
	account: Account;
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;

	constructor(
		private router: Router,
	) {
	}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.account = model.selectedAccounts[0];
			this.selectedAccountsSettings = model.selectedAccountsSettings;
		}
	}
	setupPlan = () => {
		this.router.navigateToRoute('recurring/setup-payment-plan', { id: this.account.id });
	}
}
